import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoHotjar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 114 48"
    {...props}
  >
    <g clipPath="url(#Logo_Hotjar_svg__a)">
      <path
        fill="#323232"
        d="M29.992 33.987V12.032h3.412v8.655q1.611-2.4 4.833-2.4 2.748 0 4.249 1.626 1.5 1.627 1.5 4.534v9.54h-3.41V24.92q0-3.758-3.35-3.759-1.674 0-2.747 1.011-1.074 1.011-1.075 2.843v8.972zM60.108 32.092q-2.274 2.275-5.717 2.275-3.444 0-5.734-2.275t-2.29-5.782 2.29-5.765 5.734-2.259q3.443 0 5.717 2.26 2.275 2.258 2.275 5.764t-2.275 5.782m-8.955-1.927q1.215 1.42 3.238 1.421 2.022 0 3.238-1.421 1.215-1.422 1.216-3.855 0-2.4-1.232-3.822-1.233-1.422-3.222-1.422-2.023 0-3.238 1.406-1.217 1.406-1.217 3.837 0 2.434 1.217 3.856M70.279 34.366q-4.707 0-4.707-5.055v-7.77h-2.37v-2.875h2.465l.79-4.517h2.558v4.517h6.097v2.874h-6.097v7.677q0 2.117 1.548 2.117 1.454 0 2.622-2.654l2.654 1.358q-1.96 4.329-5.56 4.328"
      />
      <path
        fill="#323232"
        d="M76.936 41q-2.275 0-3.76-1.264l1.264-2.685q.916 1.074 1.99 1.075 1.422 0 1.422-1.832V18.666h3.411v17.69q0 2.464-1.216 3.554Q78.83 41 76.936 41m2.622-24.925a2.12 2.12 0 0 1-1.517-.568 1.91 1.91 0 0 1-.6-1.454 1.96 1.96 0 0 1 .6-1.469 2.24 2.24 0 0 1 3.017 0 1.94 1.94 0 0 1 .616 1.47 1.9 1.9 0 0 1-.616 1.437 2.1 2.1 0 0 1-1.5.584M89.736 34.366q-2.622 0-4.25-1.31-1.625-1.312-1.626-3.522 0-2.021 1.69-3.429Q87.24 24.7 89.8 24.7q2.622 0 4.423 1.674V24.51q0-1.642-.837-2.543-.839-.9-2.385-.9-3.127 0-3.886 3.19l-3.128-.663q.631-2.464 2.496-3.886 1.864-1.42 4.644-1.421 3.033 0 4.786 1.595 1.752 1.596 1.753 4.66v9.445h-3.317V32.06q-1.675 2.306-4.612 2.306m.63-2.527q2.275 0 3.856-2.274v-.475q-1.581-1.895-3.855-1.895-1.326 0-2.15.648a2.02 2.02 0 0 0-.82 1.658 2.07 2.07 0 0 0 .805 1.69q.807.648 2.165.648M100.985 33.987V18.666h3.317v2.653q1.263-2.906 4.359-2.906 1.831 0 3.033 1.2 1.2 1.2 1.2 3.222a7.5 7.5 0 0 1-.411 2.37l-3.127-.316q.096-.628.126-1.264 0-2.37-1.958-2.37-1.328 0-2.228 1.407-.9 1.405-.9 3.712v7.613z"
      />
      <path
        fill="#FF3C00"
        d="M8.687 21.01c2.542-1.413 6.024-3.348 6.024-8.979h-4.216c0 3.15-1.534 4.003-3.856 5.293C4.097 18.737.615 20.67.615 26.302H4.83c0-3.15 1.534-4.003 3.856-5.292M15.984 19.716c0 3.15-1.534 4.002-3.855 5.292-2.542 1.413-6.025 3.347-6.025 8.978h4.216c0-3.15 1.534-4.002 3.856-5.292 2.542-1.413 6.024-3.347 6.024-8.978z"
      />
    </g>
    <defs>
      <clipPath id="Logo_Hotjar_svg__a">
        <path
          fill="#fff"
          d="M.615 0h113v48h-113z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoHotjar;
